import React from 'react';
import { Project } from '../../types';

type Props = {
  show: boolean;
  project: Project;
  onClose: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export default function EditProjectModal({ show, project, onClose, onSubmit }: Props) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-3xl w-full">
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <h2 className="text-2xl font-bold text-gray-900">Editar Projeto</h2>
          <input name="title" required defaultValue={project.title} className="w-full p-2 border rounded" />
          <textarea name="description" defaultValue={project.description || ''} className="w-full p-2 border rounded"></textarea>
          <div className="grid grid-cols-2 gap-4">
            <select name="status" defaultValue={project.status} className="w-full p-2 border rounded">
              <option>Ativo</option>
              <option>Concluído</option>
              <option>Arquivado</option>
            </select>
            <select name="priority" defaultValue={project.priority} className="w-full p-2 border rounded">
              <option>Baixa</option>
              <option>Média</option>
              <option>Alta</option>
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <input name="startDate" type="date" defaultValue={project.start_date || ''} className="w-full p-2 border rounded" />
            <input name="endDate" type="date" defaultValue={project.end_date || ''} className="w-full p-2 border rounded" />
          </div>
          <input name="responsible" defaultValue={project.responsible || ''} placeholder="Responsável" className="w-full p-2 border rounded" />
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-6 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-6 py-2 bg-indigo-600 text-white rounded">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
}